export default async function () {
  this.userRegistrationStatus = null;
  this.isPhoneValidAccordingToBackend = null;

  const registrationStatus = await (await import('@/helpers/checkUserRegistrationStatus')).default(this.phone, this.phone_country);

  if (registrationStatus === null) {
    this.isPhoneValidAccordingToBackend = false;
    this.error = 'Неверный формат номера телефона';
    return;
  }

  this.isPhoneValidAccordingToBackend = true;
  this.userRegistrationStatus = registrationStatus;

  if (!this.phone || this.isPhoneValidAccordingToBackend === false) {
    this.error = 'Неверный формат номера телефона';
    return;
  }

  if (this.userRegistrationStatus.registered && this.userRegistrationStatus.confirmed) {
    this.stage = 'password';
  } else {
    this.page = 'signUp';
    this.stage = 'password';
  }
}
